import * as Sentry from '@sentry/browser';
var SentryErrorLogger = /** @class */ (function () {
    function SentryErrorLogger(dsn, release) {
        Sentry.init({ dsn: dsn, release: release });
    }
    SentryErrorLogger.prototype.logError = function (error, userInfo, extraInfo) {
        if (userInfo === void 0) { userInfo = null; }
        if (extraInfo === void 0) { extraInfo = null; }
        Sentry.withScope(function (scope) {
            if (userInfo !== null) {
                scope.setUser(userInfo);
            }
            if (extraInfo !== null) {
                scope.setExtras(extraInfo);
            }
            Sentry.captureException(error);
        });
    };
    return SentryErrorLogger;
}());
export { SentryErrorLogger };
